import 'css-chunksrc/client/scenes/projectPopup/tagList/buttonTagForm/styles.scss';export default {
  "iconBox": "_iconBox_14ida_1",
  "icon": "_icon_14ida_1",
  "form": "_form_14ida_14"
};